var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoVideoIconBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "parent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.0625 63.9583L58.2292 43.125L15 0L0.3125 14.6875L28.75 43.125H21.1458C15.4167 43.125 10.7292 47.8125 10.7292 53.5417V157.708C10.7292 163.438 15.4167 168.125 21.1458 168.125H146.146C148.333 168.125 150.208 167.292 151.875 166.25L185 199.375L199.688 184.688L107.396 92.3958L79.0625 63.9583ZM31.5625 147.292V63.9583H49.5833L132.917 147.292H31.5625ZM135.729 63.9583V91.1458L198.229 153.646V48.3333L156.562 90V53.5417C156.562 47.8125 151.875 43.125 146.146 43.125H87.7083L108.542 63.9583H135.729Z",
    fill: "parent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideoIconBold);
export default __webpack_public_path__ + "static/media/NoVideoIconBold.a112f0cdd7d29375c2b8b7d6abc874a8.svg";
export { ForwardRef as ReactComponent };